// Copyright 2026, Imprivata, Inc.  All rights reserved.

export const PASSWORD_EXPIRATION_WARNING_DAYS = 14;

export const getDaysUntilExpiration = (expiresAt?: string | null): number | null => {
  if (!expiresAt) {
    return null;
  }
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const expiration = new Date(expiresAt);

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfExpiration = new Date(
    expiration.getFullYear(),
    expiration.getMonth(),
    expiration.getDate(),
  );
  const daysLeft = startOfExpiration.getTime() - startOfToday.getTime();

  // If already expired
  if (expiration.getTime() < now.getTime()) {
    return -1;
  }

  // If expires today (24h or less)
  if (daysLeft === 0 && expiration.getTime() > now.getTime()) {
    return 1;
  }

  return Math.max(0, Math.ceil(daysLeft / MS_PER_DAY));
};
